import  React, { useState, useMemo, useEffect } from 'react'; 
import { Alert, Button, Card, Layout, message } from 'antd';
import { Routes } from '../../../routes';  
import Spinner from '../../components/Spinner/Spinner';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import AIReportView from '../../components/AIReportView/AIReportView';
import AIReportsList from '../../components/AIReportsList/AIReportsList';
import useHasError from '../../hooks/useHasError'; 
import useIsLoading from '../../hooks/useIsLoading';
import useAIGetPrompt from '../../gql/hooks/useAIGetPrompt';
import useAICreatePromptReport from '../../gql/hooks/useAICreatePromptReport';
import './styles.less';

const AIReportDetailsPage = ( props ) => { 
    const { loadPrompt, promptData, promptError, promptLoading } = useAIGetPrompt();
    const [ prompt, setPrompt ] = useState( '' );
    const [ promptId, setPromptId ] = useState();
    const [ promptName, setPromptName ] = useState( '' );
    const [ reportId, setReportId ] = useState();
    const { createPromptReport } = useAICreatePromptReport();
    const [ createPromptReportLoading, setCreatePromptReportLoading ] = useState( '' );
    const { hasError } = useHasError( { items: [ promptError ] } );
    const { isLoading } = useIsLoading( { items: [ promptLoading, createPromptReportLoading ] } );

    const breadcrumbs = useMemo( () => {
        if ( promptData ) {
            return [
                { name: 'Course Studio', path: Routes.Home.buildPath() },
                { name: 'Analytics', path: Routes.Reporting.buildPath() },
                { name: 'AI Reporting', path: Routes.AIReport.buildPath() },
                { name: promptData.name }
            ];
        } else {
            return [
                { name: 'Course Studio', path: Routes.Home.buildPath() },
                { name: 'Analytics', path: Routes.Reporting.buildPath() },
                { name: 'AI Reporting', path: Routes.AIReport.buildPath() },
            ];
        }
    }, [ promptData ] );
    
    useEffect( () => {
        if ( props?.route?.params?.promptId ) {
            loadPrompt( props?.route?.params?.promptId );
        }
    }, [ promptId ] );

    useEffect( () => {
        if ( promptData ) {
            setPrompt( promptData.prompt );
            setPromptName( promptData.name );
            setPromptId( promptData.id );
        }
    }, [ promptData ] );

    const handleRunReportClick = async () => {
        setCreatePromptReportLoading( true );
        setReportId( undefined );

        const response = await createPromptReport( promptId );
        
        if ( response.success ) {
            setTimeout( () => {
                setReportId( response.response.data.promptReport.id ); 
            }, 1000 );
        } else {
            message.error( 'Error creating report. Please try again later.' );
        }

        setCreatePromptReportLoading( false );
    };

    /*************************************
     *  ANCHOR Render
     *************************************/
   
    return ( 
        <Layout className="ai-report-details-page">
            
            { /* Page header breadcrumbs */ }
            <Breadcrumbs crumbs={ breadcrumbs }/>

            { /* Loading Spinner */ }
            { isLoading &&
                <Spinner/>
            }
             
            { /* Main Content */ }
            { !isLoading &&
                <Card
                    title={ promptName }
                    className="ai-report-details-content"
                >   
                    { /* Error message */ }
                    { hasError && 
                        <Alert 
                            type="error"
                            message="Error"
                            description="An unknown error occurred. Please try again later."
                        />
                    }

                    { !hasError && 
                        <>
                            <p className="prompt">{ prompt }</p>

                            <div className="run-report">
                                <Button
                                    onClick={ handleRunReportClick }
                                >
                                    Run Report
                                </Button>
                            </div>

                            { reportId && promptId &&
                                <AIReportView 
                                    pageSize={ 10 } 
                                    reportId={ reportId }
                                    promptId={ promptId }
                                />
                            }

                            { promptId && 
                                <>
                                    <div className="history-title">Report History</div>
                                    <AIReportsList promptId={ promptId } />
                                </>
                            }
                        </>
                    }
                </Card>
            }
        </Layout>
    );
};

export default AIReportDetailsPage;
